export default "__VITE_ASSET__DyfdiPaP__"